/* eslint-disable eag/match-named-export -- Pre-existing grab-bag file with several exports */
import {type ReactNode} from 'react';

import {INLINE_EDGE_INSET} from '../../../../constants/INLINE_EDGE_INSET';

// Thin vertical rule separating toolbar groups (mock .tb__div). Inlined width +
// bg-color because the repo's prebuilt Tailwind drops fixed width + bg-color
// utilities on spans.
export const ToolbarDivider = () => (
  <span
    aria-hidden="true"
    className="flex-shrink-0"
    style={{width: 1, height: 22, background: '#DFE1E6'}}
  />
);

// Count badge overlaid on a tool-panel icon button. testId differs by branch
// (filterCountBadge on desktop, filterCountBadgeMobile on mobile) — caller
// passes the already-suffixed value.
export const FilterCountBadge = ({count, testId}: {count: number; testId: string}) => (
  <span
    className="absolute -top-1 -right-1 min-w-[16px] h-4 px-0.5 rounded-full bg-severity-informational text-white text-[10px] font-medium leading-4 text-center pointer-events-none"
    aria-hidden="true"
    data-testid={testId}
  >
    {count}
  </span>
);

// Row 1 wrapper for the presets strip, shared by mobile + desktop. The 1px
// bottom divider is inlined because border-b utilities do not emit in this
// repo's prebuilt Tailwind bundle (compute to 0px).
// White surface (T20-134467 OG feedback): the previous #F4F5F7 fill was only a
// step darker than the page and read as a rendering bug — and it also matched
// the preset pills' hover:bg-[#F4F5F7], making their hover state invisible.
// Vertical padding is inlined (not py-* utilities): the bottom padding is
// deliberately smaller than the top so the tabs sit closer to the smart-search
// row below (T20-135710 — the strip was eating too much vertical space in tight
// DG contexts like Documents). Inline because this repo's prebuilt Tailwind
// bundle drops spacing utilities that don't appear elsewhere in source.
// An INLINE grid on desktop (isInlineDesktop) keeps only INLINE_EDGE_INSET at the
// top, left and right, so the tabs line up with the table edges.
const CARD_STRIP_STYLE = {paddingTop: 8, paddingBottom: 4, borderBottom: '1px solid #EBECF0'};
const INLINE_STRIP_STYLE = {
  ...CARD_STRIP_STYLE,
  paddingTop: INLINE_EDGE_INSET,
  paddingInline: INLINE_EDGE_INSET,
};

export function PresetStripRow(props: {children: ReactNode; isInlineDesktop?: boolean}) {
  return (
    <div
      className={props.isInlineDesktop ? 'w-full bg-white' : 'w-full bg-white px-3'}
      style={props.isInlineDesktop ? INLINE_STRIP_STYLE : CARD_STRIP_STYLE}
    >
      {props.children}
    </div>
  );
}
